import { withAppContext } from '@/config/site'
import request from '@/utils/request'

// 获取邀请信息（无需登录）
export const fetchInviteInfo = async ({ inviteCode, qrToken }) => {
  const response = await request('/page/cloud-drive/share/invite-info', {
    data: withAppContext({
      invite_code: inviteCode,
      qr_token: qrToken
    })
  })
  return response.data || {}
}

// 加入共享云盘
export const joinShare = async ({ inviteCode, qrToken }) => {
  const response = await request('/page/cloud-drive/share/join', {
    data: withAppContext({
      invite_code: inviteCode,
      qr_token: qrToken
    })
  })
  return response
}

// 共享云盘列表
export const fetchShareList = async (payload = {}) => {
  const response = await request('/page/cloud-drive/share/index', {
    data: withAppContext({
      page: 1,
      pageSize: 10,
      ...payload
    })
  })

  return {
    current_page: Number(response.current_page) || 1,
    data: Array.isArray(response.data) ? response.data : [],
    from: response.from,
    last_page: Number(response.last_page) || 1,
    per_page: Number(response.per_page) || 0,
    to: response.to,
    total: Number(response.total) || 0
  }
}

// 共享云盘详情
export const fetchShareDetail = async (shareSpaceId) => {
  const response = await request('/page/cloud-drive/share/detail', {
    data: withAppContext({
      share_space_id: shareSpaceId
    })
  })
  return response.data || {}
}

// 文件列表
export const fetchShareFiles = async (shareSpaceId, payload = {}) => {
  const response = await request('/page/cloud-drive/file/index', {
    data: withAppContext({
      share_space_id: shareSpaceId,
      parent_id: 0,
      page: 1,
      pageSize: 20,
      ...payload
    })
  })

  return {
    current_page: Number(response.current_page) || 1,
    data: Array.isArray(response.data) ? response.data : [],
    from: response.from,
    last_page: Number(response.last_page) || 1,
    per_page: Number(response.per_page) || 0,
    to: response.to,
    total: Number(response.total) || 0,
    space: response.space || {}
  }
}

// 文件详情
export const fetchFileDetail = async (shareSpaceId, fileId) => {
  const response = await request('/page/cloud-drive/file/detail', {
    data: withAppContext({
      share_space_id: shareSpaceId,
      id: fileId
    })
  })
  return response.data || {}
}

// 获取 PPT 当前版本的页面切片
export const fetchPptSlices = async (fileId) => {
  const response = await request('/page/cloud-drive/file/ppt-slices', {
    data: withAppContext({
      file_id: Number(fileId)
    })
  })

  return response.data || {}
}

// 文件下载地址
export const fetchFileDownloadUrl = async (shareSpaceId, fileId, expiresIn = 1800) => {
  const response = await request('/page/cloud-drive/file/download-url', {
    data: withAppContext({
      share_space_id: shareSpaceId,
      file_id: fileId,
      expires_in: expiresIn
    })
  })
  return response.data || {}
}

// 文件预览地址
export const fetchFilePreviewUrl = async (shareSpaceId, fileId, expiresIn = 1800) => {
  const response = await request('/page/cloud-drive/file/preview-url', {
    data: withAppContext({
      share_space_id: shareSpaceId,
      file_id: fileId,
      expires_in: expiresIn
    })
  })
  return response.data || {}
}
